import { combineReducers } from 'redux';
import params from './params';
import profiles from './profiles';
import websites from './websites';

const rootReducer = combineReducers({
  params,
  profiles,
  websites,
});

export default rootReducer;
